import React, { useEffect, useState } from 'react';
import './CitationButton.scss';
import type { MessageReference } from '../../../../types/chat-message';
import { Dropdown } from '../../../../components/Dropdown';
import { Icon } from '@components/Icon';

interface CitationButtonProps {
  references: MessageReference[];
}

const getDomain = (uri: string): { name: string; favicon: string | null } => {
  try {
    const url = new URL(uri);
    const name = url.hostname.replace(/^www\./, '');
    const favicon = `https://www.google.com/s2/favicons?domain=${url.hostname}&sz=32`;
    return { name, favicon };
  } catch {
    return { name: 'Web', favicon: null };
  }
};

const CitationButton: React.FC<CitationButtonProps> = ({ references }) => {

  if (!references || references.length === 0) {
    return null;
  }

  const items = references.map((reference: MessageReference, index: number) => {
    const { name, favicon } = getDomain(reference.uri);
    // Ưu tiên snippet từ BE, fallback sang fetched description
    const snippet = reference.description || null;

    return {
      key: String(index),
      label: (
        <div className="citation-dropdown-item-content">
          {/* Row 1: favicon + domain + external icon */}
          <div className="citation-dropdown-row-top">
            <div className="citation-dropdown-source">
              {favicon && (
                <img src={favicon} alt={name} className="citation-dropdown-favicon" />
              )}
              <span className="citation-dropdown-domain">{name}</span>
            </div>
            <Icon name="ExternalLinkIcon" className="citation-dropdown-external" />
          </div>
          {/* Row 2: title */}
          <div className="citation-dropdown-title">{reference.title}</div>
          {/* Row 3: snippet / meta description */}
          {snippet && (
            <div className="citation-dropdown-snippet">{snippet}</div>
          )}
        </div>
      ),
      onClick: () => window.open(reference.uri, '_blank'),
    };
  });

  const { name: firstName } = getDomain(references[0].uri);

  return (
      <Dropdown
          items={items}
          placement="topLeft"
          overlayClassName="citation-dropdown-overlay"
          trigger={['hover']}
      >
        <button
            className="citation-button"
            onClick={(e) => {
              e.preventDefault();
            }}
            aria-label={`View ${references.length} source${references.length > 1 ? 's' : ''}`}
            type="button"
        >
          {/* <span className="citation-button-label">Link nguồn</span> */}
          <span className="citation-button-label">{firstName}</span>
          {references.length > 1 && (
              <span className="citation-count">+{references.length - 1}</span>
          )}
        </button>
      </Dropdown>
  );
};

export default CitationButton;
